import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatViews } from "@/lib/video";

interface RelatedListProps {
  videos: Video[];
}

export default function RelatedList({ videos }: RelatedListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="mb-4 flex items-center gap-2 text-base font-semibold text-foreground-950">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
          <i className="ri-play-list-2-line text-base" />
        </span>
        相关推荐
      </h2>
      <div className="flex flex-col divide-y divide-background-200">
        {videos.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group flex cursor-pointer gap-3 py-3 first:pt-0"
          >
            <span className="relative h-16 w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} - 逼特逼视频`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute bottom-1 right-1 rounded bg-foreground-950/75 px-1 py-0.5 text-[10px] text-background-50">
                {video.duration}
              </span>
            </span>
            <span className="min-w-0 flex-1">
              <span className="line-clamp-2 text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
                {video.title}
              </span>
              <span className="mt-1.5 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-play-circle-line text-sm" />
                {formatViews(video.views)} 次播放
              </span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}